module.exports = __webpack_public_path__ + "img/fn-goal-12.7af3c0c7.jpg";